import React, { useState } from "react";
import Input from "../../../common/Input";
import {Row, Col, Button, Card, ListGroup} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { testSmtpConnection} from "../../../../_apis/api";
import Checkbox from "../../../common/CheckBox";
import {setSaveEmailSmtp} from "../../../../_reducers/activitySlice";
import {setEmailSmtp} from "../../../../_reducers/settingsSlice";
import {
    emailSettingsWildcardsList,
} from "../../../../_helpers/commonFunctions";
import Editor from 'react-simple-wysiwyg';
import {useTranslation} from "../../../../hooks/useTranslation";

const SettingsEmailSMTP = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const SETTINGS = useSelector( (state) => state.SETTINGS);
    const smtpSettings = useSelector( (state) => state.SETTINGS.emailSmtp);
    const ACTIVITY = useSelector( (state) => state.ACTIVITY);
    const [showWildcardsList, setShowWildcardsList] = useState(false);
    const [showWildcardsListEditor, setShowWildcardsListEditor] = useState(false);
    let wildcardsList = emailSettingsWildcardsList();
    let wildcardsListEditor = emailSettingsWildcardsList();
    const [editorValue, setEditorValue] = useState(smtpSettings.mailBody);

    const handleOnChange = (e, type="default", ddname = '') => {
        // Set if editing the form
        if (!ACTIVITY.saveEmailSMtp) {
            dispatch(setSaveEmailSmtp(true));
        }
        let name;
        let value;
        if (type === 'dd') {
            name = ddname;
            value = e.value;
        } else {
            name = e.target.name;
            value = e.target.value;
        }
        // Set settings data
        let emailSmtpSettings = Object.assign({}, SETTINGS.emailSmtp);
        let setEmailSmtpSettings = {};
        if(name === "smtpOptionPrimer" && value === "active"){
            setEmailSmtpSettings["smtpOption"] = "primer";
        } else if(name === "smtpOptionCustom" && value === "active"){
            setEmailSmtpSettings["smtpOption"] = "custom";
        } else if(name === "encryptionNone" && value === "on"){
            setEmailSmtpSettings["encryptionType"] = "none";
        } else if(name === "encryptionSSL" && value === "on"){
            setEmailSmtpSettings["encryptionType"] = "SSL/TLS";
        } else if(name === "encryptionSTART" && value === "on"){
            setEmailSmtpSettings["encryptionType"] = "Start TLS";
        } else if(name === "authenticationTrue" && value === "on"){
            setEmailSmtpSettings["smtpAuthentication"] = "true";
        } else if(name === "authenticationFalse" && value === "on"){
            setEmailSmtpSettings["smtpAuthentication"] = "false";
        } else if(name === "mailBody"){
            setEmailSmtpSettings["mailBody"] = e.target.value;
            setEditorValue(value);
        } else {
            setEmailSmtpSettings[name] = value;
        }
        setEmailSmtpSettings = {...emailSmtpSettings, ...setEmailSmtpSettings}
        if (setEmailSmtpSettings.password !== '' && setEmailSmtpSettings.username !== '') {
            // setEnableActive(false);
        }
        dispatch(setEmailSmtp(setEmailSmtpSettings));
    }
    const handleAddWildcard = (e, item, object) => {
        if (!ACTIVITY.saveEmailSMtp) dispatch(setSaveEmailSmtp(true));

        let emailSmtpSettings = Object.assign({}, SETTINGS.emailSmtp);
        let setEmailSmtpSettings = {};
        if(object === "subject"){
            setEmailSmtpSettings["subject"] = `${emailSmtpSettings?.subject} ${item}`;
        } else if(object === "mailBody"){
            let itemEditor = `<p>${item}</p>`;
            const val = `${emailSmtpSettings?.mailBody}${itemEditor}`;
            setEmailSmtpSettings["mailBody"] = val;
            setEditorValue(val);
        }
        setEmailSmtpSettings = {...emailSmtpSettings, ...setEmailSmtpSettings}
        dispatch(setEmailSmtp(setEmailSmtpSettings));
    };

    const testSmtpConnectionButton = () => {
        dispatch(testSmtpConnection(smtpSettings))
    }
    return (
        <>
            <Row>
                <Col sm="12" className="mb-3 d-flex align-items-center justify-content-start">
                    <div className="mb-3 d-flex align-items-center justify-content-start">
                        {t('SettingsEmailSMTP.usePrimerSmtp')}
                        <Checkbox
                            className="ml-2 mb-2"
                            name="smtpOptionPrimer"
                            key = {Math.random()}
                            defaultValue={smtpSettings.smtpOption === "primer" ? "active" : "inactive"}
                            value={ smtpSettings.smtpOption === 'primer' ? "inactive" : "active" }
                            onChange = {(e) => handleOnChange(e) }
                        />
                    </div>
                </Col>
                <Col sm="12" className="mb-3 d-flex align-items-center justify-content-start">
                    <div className="mb-3 d-flex align-items-center justify-content-start">
                        {t('SettingsEmailSMTP.useCustomSmtp')}
                        <Checkbox
                            className="ml-2 mb-2"
                            name="smtpOptionCustom"
                            key = {Math.random()}
                            defaultValue={smtpSettings.smtpOption === "custom" ? "active" : "inactive"}
                            value={ smtpSettings.smtpOption === 'custom' ? "inactive" : "active" }
                            onChange = {(e) => handleOnChange(e) }
                        />
                    </div>
                </Col>
                <Row></Row>
                {smtpSettings.smtpOption === "custom" &&
                    <>
                        <Row>
                            <Col sm="12" md="6">
                                <label className="w-100 text-muted">
                                    <i>{t('SettingsEmailSMTP.smtpSettings')}</i>
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <div className="mb-3 w-50">
                                <Input
                                    label={t('SettingsEmailSMTP.fromEmail.fromEmail')}
                                    name = "fromEmail"
                                    value = {smtpSettings.fromEmail}
                                    placeholder={t('SettingsEmailSMTP.fromEmail.placeholder')}
                                    required={true}
                                    charLimit="30"
                                    onChange = {(e) => handleOnChange(e, 'default', 'fromEmail') }
                                />
                            </div>
                        </Row>
                        <div className="mb-3 w-25">
                            <Input
                                label={t('SettingsEmailSMTP.username.username')}
                                name = "username"
                                value = {smtpSettings.username}
                                placeholder={t('SettingsEmailSMTP.username.placeholder')}
                                required={true}
                                charLimit="30"
                                onChange = {(e) => handleOnChange(e, 'default', 'username') }
                            />
                        </div>
                        <div className="mb-3 w-25">
                            <Input
                                label={t('SettingsEmailSMTP.password.password')}
                                name = "password"
                                type={"password"}
                                value = {smtpSettings.password}
                                placeholder={t('SettingsEmailSMTP.password.placeholder')}
                                required={true}
                                allowShowPassword={true}
                                charLimit="30"
                                onChange = {(e) => handleOnChange(e, 'default', 'password') }
                            />
                        </div>
                        <Col sm="12" className="d-flex align-items-center mb-3">
                            <span className="mr-3">{t('SettingsEmailSMTP.encryptionType')}</span>
                            {t('SettingsEmailSMTP.none')} <input className="ml-1 mr-1" type="radio" checked={smtpSettings.encryptionType === "none"} name="encryptionNone" onChange = {(e) => handleOnChange(e, 'default', 'encryptionNone') } />
                            SSL/TLS <input className="ml-1 mr-1" type="radio" name="encryptionSSL" checked={smtpSettings.encryptionType === "SSL/TLS"} onChange = {(e) => handleOnChange(e, 'default', 'encryptionSSL') } />
                            {t('SettingsEmailSMTP.start')} TLS <input className="ml-1 mr-1" type="radio" name="encryptionSTART" checked={smtpSettings.encryptionType === "Start TLS"} onChange = {(e) => handleOnChange(e, 'default', 'encryptionSTART') } />
                        </Col>
                        <Row></Row>
                        <Col sm="12">
                            <label className="w-100 text-muted">
                                <i>{t('SettingsEmailSMTP.message')}</i>
                            </label>
                        </Col>
                        <Col sm="12" className="d-flex align-items-center">
                            <span className="mr-3">{t('SettingsEmailSMTP.smtpAuthentication')}</span>
                            {t('SettingsEmailSMTP.yes')} <input className="ms-2 mr-2" type="radio" checked={smtpSettings.smtpAuthentication === "true"} name="authenticationTrue" onChange = {(e) => handleOnChange(e, 'default', 'authenticationTrue') } />
                            {t('SettingsEmailSMTP.no')} <input className="ms-2 mr-2" type="radio" checked={smtpSettings.smtpAuthentication !== "true"} name="authenticationFalse" onChange = {(e) => handleOnChange(e, 'default', 'authenticationFalse') } />
                        </Col>
                        <div className="mb-3 mt-3 w-25">
                            <Input
                                label="SMTP Server"
                                name = "smtpServer"
                                value = {smtpSettings.smtpServer}
                                placeholder= {t('SettingsEmailSMTP.smtpServerPlaceholder')}
                                required={true}
                                charLimit="30"
                                onChange = {(e) => handleOnChange(e, 'default', 'smtpServer') }
                            />
                        </div>
                        <div className="mb-3 mt-3 w-25">
                            <Input
                                label={t('SettingsEmailSMTP.smtpPort')}
                                name = "smtpPort"
                                typ="number"
                                value = {smtpSettings.smtpPort}
                                placeholder={t('SettingsEmailSMTP.smtpPortPlaceholder')}
                                required={true}
                                charLimit="30"
                                onChange = {(e) => handleOnChange(e, 'default', 'smtpPort') }
                            />
                        </div>
                    </>
                }
                <Row className="mt-3"></Row>
                <Col sm="12">
                    <label className="w-100 text-muted">
                        <i>{t('SettingsEmailSMTP.emailSettings')}</i>
                    </label>
                </Col>
                <div className="mb-3 w-25">
                    <Input
                        label={t('SettingsEmailSMTP.correspondentName.correspondentName')}
                        name = "correspondentName"
                        value = {smtpSettings.correspondentName}
                        placeholder={t('SettingsEmailSMTP.correspondentName.required')}
                        required={true}
                        charLimit="30"
                        onChange = {(e) => handleOnChange(e, 'default', 'correspondentName') }
                    />
                </div>
                <Row>
                    <div className="mb-3 mt-3 w-50">
                        <Input
                            label={t('SettingsEmailSMTP.mailSubject.mailSubject')}
                            name = "subject"
                            value = {smtpSettings.subject}
                            placeholder={t('SettingsEmailSMTP.mailSubject.placeholder')}
                            required={true}
                            charLimit="30"
                            onChange = {(e) => handleOnChange(e, 'default', 'subject') }
                        />
                        <div className="col-12 col-md-4 d-flex align-items-end">
                            <button
                                type="button"
                                className="btn btn-primary btn-sm mb-1 mt-2"
                                onClick={() => setShowWildcardsList(!showWildcardsList)}
                            >
                                {t('SettingsEmailSMTP.addWildcard')}
                            </button>
                        </div>
                    </div>
                    {showWildcardsList && (
                        <Card className="wildcards-list">
                            <Card.Title>
                                {t('SettingsEmailSMTP.wildcards')}{" "}
                                <small>{t('SettingsEmailSMTP.message2')}</small>
                            </Card.Title>
                            <ListGroup>
                                {wildcardsList &&
                                    wildcardsList.length > 0 &&
                                    wildcardsList.map((item) => {
                                        return (
                                            <ListGroup.Item
                                                title="Click to Add"
                                                onClick={(e) =>
                                                    handleAddWildcard(e, item, "subject")
                                                }
                                                key={Math.random()}
                                            >
                                                {item}
                                            </ListGroup.Item>
                                        );
                                    })}
                            </ListGroup>
                        </Card>
                    )}
                </Row>
                <Row>
                    <Editor
                        value={editorValue}
                        name="mailBody"
                        onChange={(e) => handleOnChange(e, 'rte', "mailBody")}
                    />
                    <div className="col-12 col-md-4 d-flex align-items-end">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm mb-1 mt-2"
                            onClick={() => setShowWildcardsListEditor(!showWildcardsListEditor)}
                        >
                            {t('SettingsEmailSMTP.addWildcard')}
                        </button>
                    </div>
                </Row>
                {showWildcardsListEditor && (
                    <Card className="wildcards-list">
                        <Card.Title>
                            {t('SettingsEmailSMTP.wildcards')}{" "}
                            <small>{t('SettingsEmailSMTP.message2')}</small>
                        </Card.Title>
                        <ListGroup>
                            {wildcardsListEditor &&
                                wildcardsListEditor.length > 0 &&
                                wildcardsListEditor.map((item) => {
                                    return (
                                        <ListGroup.Item
                                            title="Click to Add"
                                            onClick={(e) =>
                                                handleAddWildcard(e, item, "mailBody")
                                            }
                                            key={Math.random()}
                                        >
                                            {item}
                                        </ListGroup.Item>
                                    );
                                })}
                        </ListGroup>
                    </Card>
                )}
                <Col sm="12">
                    <Button type="button" onClick={ () => testSmtpConnectionButton() }>{t('SettingsEmailSMTP.testSMTPConnection')}</Button>
                </Col>
            </Row>
        </>
    )
}

export default SettingsEmailSMTP;
